/**
 * Use this function to bind all available actions and reducer data to props at:
 *    this.props.actions
 *    this.props.reducers
 */
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../actions/ActionCreators';
import UserActionCreators from '../actions/UserActionCreators';
import MetadataActionCreators from '../actions/MetadataActionCreators';
import PatientActionCreators from '../actions/PatientActionCreators';
import FileActionCreators from '../actions/FileActionCreators';
import InvitationActionCreators from '../actions/InvitationActionCreators';
import * as ActivityLogActionCreators from '../actions/ActivityLogActionCreators';
import * as TestimonialActionCreators from '../actions/TestimonialActionCreators';
import FPPActionCreators from '../actions/FPPActionCreators';
import TeamActionCreators from '../actions/TeamActionCreators';

// Mixin the container's props with Redux data
// the state here means the state of entire application (store state)
// data will be available at `this.props.reducers.{REDUCER_NAME}
function mapStateToProps(state) {
  return {
    ...state, // TODO: refactor this out later to make all data under .reducers
    reducers: state,
  };
}

// in the Container you can call actions like `this.props.actions.{ACTION_CREATOR_NAME}`
// for example:
//   this.props.actions.createSuccessAlerts('Success !');
function mapDispatchToProps(dispatch) {
  const allActions = {
    ...ActionCreators,
    ...PatientActionCreators,
    ...FileActionCreators,
    ...UserActionCreators,
    ...MetadataActionCreators,
    ...InvitationActionCreators,
    ...ActivityLogActionCreators,
    ...TestimonialActionCreators,
    ...FPPActionCreators,
    ...TeamActionCreators,
  };
  return {
    actions: bindActionCreators(allActions, dispatch),
  };
}

export default function connectActionsAndReducers(Container) {
  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(Container);
}



// WEBPACK FOOTER //
// ./src/toolbox/connectActionsAndReducers.js